module.exports = __webpack_public_path__ + "static/media/uva_logo.7676f33a.svg";